import { IJobElements } from "@types"
import { protectedApi } from "store/Api"

const devicesJobElements = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        deviceJobElements: builder.query<IJobElements[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/job_elements`,
                }
            },
        }),
    }),
})

export const { useDeviceJobElementsQuery } = devicesJobElements
